import { Box } from '@mui/material';
import React from 'react';

type IncomingBankPaymentTransferArrowProps = {
  showArrow: boolean;
  children: React.ReactNode;
};

export const IncomingBankPaymentTransferArrow = (props: IncomingBankPaymentTransferArrowProps) => {
  const { showArrow, children } = props;
  const arrowSize = 20;
  return (
    <Box
      className={showArrow ? 'showArrow' : ''}
      sx={{
        p: 2,
        position: 'relative',
        background: '#fff',
        '&.showArrow': {
          borderBottom: '1px solid #e0e0e0',
          '&::after, &::before': {
            top: '100%',
            left: '50%',
            border: 'solid transparent',
            content: '""',
            height: 0,
            width: 0,
            position: 'absolute',
            pointerEvents: 'none',
          },
          '&::after': {
            borderColor: 'rgba(255, 255, 255, 0)',
            borderTopColor: '#fff',
            borderWidth: `${arrowSize}px`,
            marginLeft: `-${arrowSize}px`,
          },
          '&::before': {
            borderColor: 'rgba(224, 224, 224, 0)',
            borderTopColor: '#e0e0e0',
            borderWidth: `${arrowSize + 1}px`,
            marginLeft: `-${arrowSize + 1}px`,
          },
        },
      }}
    >
      {children}
    </Box>
  );
};
